module.exports = __webpack_public_path__ + "img/no-image.dac3e867.webp";